import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCDg9PaaVKWGhu23vqsaIuc0sbBNVJabM0",
    authDomain: "foodiera-vic.firebaseapp.com",
    databaseURL: "https://foodiera-vic-default-rtdb.firebaseio.com",
    projectId: "foodiera-vic",
    storageBucket: "foodiera-vic.appspot.com",
    messagingSenderId: "219831306133",
    appId: "1:219831306133:web:8e5972ed7f08cdec3cd89c",
    measurementId: "G-1Y5BG3W1D4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const cloudStore = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const RTdatabase = getDatabase(app);
auth.useDeviceLanguage()